import { numberToPrettyString } from '@cian/utils';
import { NBSP } from '../../constants/symbols';

export function formatAuctionPoints(points: number): string {
  return `${numberToPrettyString(points)}${NBSP}Б`;
}
